import { Col, Form, Input, Radio, Row } from "antd";
import styles from "./ApprovalForm.module.less";
import type { FlowSkipType } from "@/constants";
import { PrimaryButton } from "../ui/buttons/PrimaryButton";

export type ApprovalFormFields = {
  skipType: FlowSkipType;
  message: string;
};

type Props = {
  onApprovalSubmit: (values: ApprovalFormFields) => void;
};

export function ApprovalForm({ onApprovalSubmit }: Props) {
  const [form] = Form.useForm<ApprovalFormFields>();

  const onSubmit = async () => {
    const values = await form.validateFields();

    onApprovalSubmit(values);
  };
  return (
    <div className={styles.approvalForm}>
      <Form form={form}>
        <Row>
          <Col span={24} style={{ textAlign: "left" }}>
            <Form.Item<ApprovalFormFields>
              label="审批意见"
              name="skipType"
              rules={[{ required: true, message: "请选择审批意见" }]}
              className={styles.marginBottomResize}
            >
              <Radio.Group
                style={{
                  justifyContent: "left",
                }}
                options={[
                  { value: "PASS", label: "通过" },
                  { value: "REJECT", label: "驳回" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item<ApprovalFormFields>
              label="意见说明"
              name="message"
              className={styles.marginBottomResize}
            >
              <Input.TextArea placeholder="请输入" maxLength={300} />
            </Form.Item>
          </Col>
        </Row>

        <div className={styles.footer}>
          <PrimaryButton onClick={onSubmit}>提交</PrimaryButton>
        </div>
      </Form>
    </div>
  );
}
